export const FORM_ALERT = 'FORM_ALERT'
export const FORM_FIELD = 'FORM_FIELD'
export const RESET_FORM_DATA = 'RESET_FORM_DATA'
export const SET_FORM_STATE = 'SET_FORM_STATE'
